import validate from "/codebuild/output/src2297554842/src/and-dine-hub/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/codebuild/output/src2297554842/src/and-dine-hub/middleware/auth.global.ts";
import clear_45messages_45global from "/codebuild/output/src2297554842/src/and-dine-hub/middleware/clear-messages.global.ts";
import zz_45analytics_45global from "/codebuild/output/src2297554842/src/and-dine-hub/middleware/zz-analytics.global.ts";
import manifest_45route_45rule from "/codebuild/output/src2297554842/src/and-dine-hub/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  clear_45messages_45global,
  zz_45analytics_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  loading: () => import("/codebuild/output/src2297554842/src/and-dine-hub/middleware/loading.ts")
}